import { Component, OnInit, ViewChild, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDatepicker } from '@angular/material/datepicker';
import { ProductClassification } from 'src/app/enum/ProductClassification';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ProductService } from 'src/app/services/product.service';
import { UserdataService } from 'src/app/services/userdata.service';
import { ManageAdhocPopupComponent } from '../manage-adhoc-popup/manage-adhoc-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Configuration } from 'src/app/enum/Configuration';
import { TariffDataServicesService } from 'src/app/services/tariff-data-services.service';
import { ApplicationStatusType, CountryType } from 'src/app/enum/application-status-type';
import { DebitFormDataService } from 'src/app/services/debit-form-data.service';
import { UtilityService } from 'src/app/services/utility.service';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { FiberService } from 'src/app/services/fiber.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { productchangeType } from 'src/app/enum/ProductchangeType';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-manage-adhoc',
  templateUrl: './manage-adhoc.component.html',
  styleUrls: ['./manage-adhoc.component.scss']
})
export class ManageAdhocComponent implements OnInit {
  form: FormGroup
  productcategory
  @ViewChild('filterInput') filterInput: any;
  productclassification = ProductClassification
  configuration = Configuration
  isPhysicalContract = false;
  isResellerCustomer = false;
  isvumatel = false;
  verifyedlist: any;
  genderValidator = false;
  filteredList
  serviceprovider: any;
  filteredList2
  productlist: any;
  filteredList3
  title: any = [{ key: 1, value: 'Mr' }, { key: 2, value: 'Miss' }, { key: 3, value: 'Mrs' }, { key: 4, value: 'Dr' }]
  country: any = [{ key: 1, value: 'South Africa' }]
  languageList: any;
  filteredList4
  promocode
  isshow = false;
  groupedProducts
  searchTerm
  debit: any = []
  selectedproductsubcategoryId
  emailError: string = "";
  isMultipleConnectionFee
  withOnt
  withOutOnt
  application: any = {}
  isont: any;
  connectionFeeDetails: any;
  customer: any
  productClassification: any;
  address: any;
  ispshow: boolean;
  resellerlist: any;
  filteredList5
  banklist: any;
  filteredList6
  filteredList7
  date
  first = false;
  ip: any;
  dateip: boolean;
  dis = true;
  data: any = [
    { id: 1, documenttype: 'Proof of Residence', date: '', filename: '', fileObject: null, action: false, type: '2' },
    { id: 2, documenttype: 'Proof of ID/Passport', date: '', filename: '', fileObject: null, action: false, type: '1' },
    { id: 3, documenttype: 'Manual Contract', date: '', filename: '', fileObject: null, action: false, type: '8' },
    { id: 4, documenttype: 'Signed Debit Order', date: '', filename: '', fileObject: null, action: false, type: '9' }
  ];

  typeofaccount: any = [{ key: 1, value: 'Savings' }, { key: 2, value: 'Current' }, { key: 3, value: 'Transmission' }]
  debitorder: any = [{ key: 0, value: '1st' }, { key: 1, value: '15th' }, { key: 2, value: '25th' }]
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "DocumentType",
    "Date",
    "FileName",
    "Action",
  ];
  file: File;
  fileName: string;
  isFileSelected = false;
  FileExtention: string;
  filedate: any;
  applicationid: any;
  referenceno: any;
  mobileNumberValue: any;
  landLineNumberValue: string;
  primaryContactNumberValue: any;
  maxDate: Date;
  BusinessmobileNumber: string;
  data1
  promocodelist: any[]
  loadingMore: any = false;
  searchText: string;
  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private lookupdataservice: LookupDataServiceService,
    private product: ProductService,
    private userdataservice: UserdataService,
    private applicationdataservice: ApplicationDataService,
    private matdialog: MatDialog,
    private tariffdataservice: TariffDataServicesService,
    private debitform: DebitFormDataService,
    private UtilityService: UtilityService,
    private fiberservice: FiberService,
    private navigation: NavigationService,
  ) { }
  @ViewChild('startDatePicker') startDateDatePicker: MatDatepicker<Date>;


  ngOnInit(): void {
    this.data1 = this.data;

    this.dataSource = new MatTableDataSource(this.data1);
    const today = new Date();
    this.maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    this.initform();
    this.disable();
    this.getdetails();





  }

  initform() {
    this.form = this.formBuilder.group({
      customer: [],
      serviceProvider: [null, Validators.required],
      product: [null, Validators.required],
      promoCode: [null],
      reference: [],
      addressLine1: [null, Validators.required],
      addressLine2: [null, Validators.required],
      city: [null, Validators.required],
      region: [null, Validators.required],
      pinCode: [],
      country: [1],
      title: [1, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      gender: [1],
      dateOfBirth: [, Validators.required],
      homeLanguage: [null, Validators.required],
      identificationNumber: [, Validators.required],
      primaryContactNumber: [, Validators.required],
      mobileNumber: [null],
      landLineNumber: [null],
      email: [, Validators.required],
      ownerShip: ["1"],
      legalOwnerName: [],
      legalOwnerContactNumber: [null, Validators.pattern('^[0-9]*$')],
      resellerCustomer: [],
      accountHolderName: [],
      address: ['South Africa'],
      bank: [],
      code: [],
      accountNumber: [],
      accountType: [],
      amount: [],
      dateOfDebitOrderRun: [],
      onceOffFee: [],
      beneficiaryName: ['AFRIHOST HOME CONNECT(PTY) LTD'],
      abbreviatedName: ['HM CONNECT'],
      beneficiaryAddress: ['Home-Connect Pty Ltd,Design Quarter Block 4, First Floor, Leslie Avenue, Fourways, Sandton, South Africa'],
      personname: [],
      personLastName: [],
      BusinessmobileNumber: [],
      businessemail: [],
      personIdentification: [],
    })
    this.form.get('addressLine1')?.valueChanges.subscribe(() => this.updateAddress());
    this.form.get('addressLine2')?.valueChanges.subscribe(() => this.updateAddress());
    this.form.get('city')?.valueChanges.subscribe(() => this.updateAddress());
    this.form.get('region')?.valueChanges.subscribe(() => this.updateAddress());
    this.form.get('pinCode')?.valueChanges.subscribe(() => this.updateAddress());
    this.form.get('firstName')?.valueChanges.subscribe(() => this.updateAddress());
    this.form.get('lastName')?.valueChanges.subscribe(() => this.updateAddress());


    this.form.get('beneficiaryName')?.disable();
    this.form.get('abbreviatedName')?.disable();
    this.form.get('beneficiaryAddress')?.disable();
    this.form.get('address')?.disable();
    this.form.get('code')?.disable();
    this.form.get('amount')?.disable();
    this.form.get('onceOffFee')?.disable();


  }
  disable() {
    this.form.get('product')?.disable();
    this.form.get('title')?.disable();
    this.form.get('firstName')?.disable();
    this.form.get('lastName')?.disable();
    this.form.get('identificationNumber')?.disable();
    this.form.get('primaryContactNumber')?.disable();
    this.form.get('mobileNumber')?.disable();
    this.form.get('landLineNumber')?.disable();
    this.form.get('email')?.disable();
    this.form.get('gender')?.disable();

  }
  enable() {
    this.form.get('title').enable();
    this.form.get('firstName')?.enable();
    this.form.get('lastName')?.enable();
    this.form.get('identificationNumber')?.enable();
    this.form.get('primaryContactNumber')?.enable();
    this.form.get('mobileNumber')?.enable();
    this.form.get('landLineNumber')?.enable();
    this.form.get('email')?.enable();
    this.form.get('gender')?.enable();

  }
  clearData() {
    this.data.forEach(item => {
      item.date = '';              // Reset date to empty string
      item.filename = '';          // Reset filename to empty string
      item.fileObject = null;      // Reset fileObject to null
      item.action = false;         // Reset action to false
    });
    // If you are using a dataSource for a table, refresh it as well
    this.dataSource = new MatTableDataSource(this.data);
  }

  click(event: MatCheckboxChange) {
    console.log(event.checked)
    if (event.checked) {
      this.isPhysicalContract = true;
      this.isshow = false;
      this.isvumatel = false
      this.initform();
      this.enable();
      this.clearData()
    }
    else {
      this.isPhysicalContract = false;
      this.isResellerCustomer = false;
      this.isshow = false;
      this.isvumatel = false
      this.dataSource = new MatTableDataSource(this.data1);
      this.initform();
      this.disable();
      this.clearData()

    }
  }

  resellerclick(event1: MatCheckboxChange) {
    console.log('df', event1.checked)

    if (event1.checked) {
      this.isResellerCustomer = true;
      this.isvumatel = false
      this.getresellercustomer()
      this.initform();
      this.disable()
      this.clearData()
      this.form.get('ownerShip')?.disable();


    }
    else {
      this.isResellerCustomer = false;
      this.isvumatel = false
      this.initform();
      this.enable();
      this.clearData()
      this.form.get('ownerShip')?.enable();


    }
  }
  getresellercustomer() {
    this.lookupdataservice.getResellerUsers().subscribe((result) => {
      this.resellerlist = result;
      this.filteredList5 = [...this.resellerlist]
    })
  }
  onInputChange() {
    const inputValue = this.form.get('mobileNumber')?.value || '';
    if (inputValue.length === 3) {
      this.mobileNumberValue = '';
      this.form.get('mobileNumber')?.setValue('');
      return;
    }
    if (!inputValue.startsWith('+27')) {
      this.form.get('mobileNumber')?.setValue('+27' + inputValue.replace('+27', ''));
    } else {
      if (inputValue.length < 3) {
        this.form.get('mobileNumber')?.setValue('');
        this.mobileNumberValue = '';
      }
    }
    this.mobileNumberValue = this.form.get('mobileNumber')?.value;

    const inputValue1 = this.form.get('BusinessmobileNumber')?.value || '';
    if (inputValue1.length === 3) {
      this.BusinessmobileNumber = '';
      this.form.get('BusinessmobileNumber')?.setValue('');
      return;
    }
    if (!inputValue1.startsWith('+27')) {
      this.form.get('BusinessmobileNumber')?.setValue('+27' + inputValue1.replace('+27', ''));
    } else {
      if (inputValue1.length < 3) {
        this.form.get('BusinessmobileNumber')?.setValue('');
        this.BusinessmobileNumber = '';
      }
    }
    this.BusinessmobileNumber = this.form.get('BusinessmobileNumber')?.value;
  }
  onLandLineInputChange() {
    const inputValue = this.form.get('landLineNumber')?.value || '';

    if (inputValue.length === 3) {
      this.landLineNumberValue = '';
      this.form.get('landLineNumber')?.setValue('');
      return;
    }

    if (!inputValue.startsWith('+27')) {
      this.form.get('landLineNumber')?.setValue('+27' + inputValue.replace('+27', ''));
    } else {

      if (inputValue.length < 3) {
        this.form.get('landLineNumber')?.setValue('');
        this.landLineNumberValue = '';
      }
    }
    this.landLineNumberValue = this.form.get('landLineNumber')?.value;
  }
  onPrimaryContactInputChange() {
    const inputValue = this.form.get('primaryContactNumber')?.value || '';

    if (inputValue.length === 0) {
      this.primaryContactNumberValue = '';
      this.form.get('primaryContactNumber')?.setValue('');
      return;
    }

    if (!inputValue.startsWith('+27')) {
      this.form.get('primaryContactNumber')?.setValue('+27' + inputValue.replace('+27', ''));
    } else {
      if (inputValue.length < 3) {
        this.form.get('primaryContactNumber')?.setValue('');
        this.primaryContactNumberValue = '';
      }
    }
    this.primaryContactNumberValue = this.form.get('primaryContactNumber')?.value;
  }

  getdetails() {
    this.lookupdataservice.getVerifiedUsers().subscribe((result) => {
      this.verifyedlist = result
      this.filteredList = [...this.verifyedlist]
    })
    this.lookupdataservice.getServiceProvider().subscribe((result) => {
      this.serviceprovider = result;
      this.filteredList2 = [...this.serviceprovider]

    })
    this.lookupdataservice.getlanguage(true).subscribe((result) => {
      this.languageList = result;
      this.filteredList4 = [...this.languageList];
    })
    this.debitform.getBankList().subscribe((result) => {
      this.banklist = result;
      this.filteredList6 = [...this.banklist]

    })
  }
  getbranchcode() {
    let value = this.form.value.bank;
    console.log('bank', value)
    let code = this.banklist.find(item => item.name == value)
    console.log('bankdetails', code)
    this.form.controls['code'].setValue(code.code)
  }
  getuserdetails() {
    let value;
    if (this.form.value.customer) {
      value = this.form.value.customer;
      this.isvumatel = false;
      this.initform()
      this.disable()
      this.form.get('customer').setValue(value)
    }
    else {
      value = this.form.value.resellerCustomer;
      this.isvumatel = false;
      this.initform()
      this.disable()
      this.form.get('resellerCustomer').setValue(value)
    }
    this.groupedProducts = null

    this.userdataservice.getUserById(value).subscribe((result) => {
      this.customer = result;
      this.form.patchValue({
        ...result,
        gender: result.gender.toString(),

      })
      console.log('recustomer', this.customer);

      this.applicationdataservice.getExistingBankDetails(value).subscribe((result) => {
        this.debit = result
        if (!this.debit) {
          this.debit = { id: '0' };
        }
        if (this.form.value.resellerCustomer) {
          this.form.patchValue({
            ...result,

          })
        }

      })
    })

  }

  getproductclassification() {
    console.log(this.form.value)
    this.form.get('promoCode')?.setValue(null);

    let data = this.form.value;
    if (data.serviceProvider == '1') {
      this.isvumatel = true;
      this.form.addControl('VumatelArea', this.formBuilder.control(false, Validators.required));
    }

    else {

      if (this.form.contains('VumatelArea')) {
        this.form.removeControl('VumatelArea');
      }
      this.isvumatel = false;
    }
    if (this.form.value.serviceProvider == this.configuration.RainServiceProviderId) {
      Swal.fire('warning!,', 'This Service Provider is no longer Available', "warning");
      return;
    }
    let value: any = {
      serviceProviderId: data.serviceProvider,
    }
    this.product.getProductClassificationByServiceProviderId(value).subscribe((result) => {
      this.productClassification = result;
      value.productClassification = (value.serviceProviderId == 43) ? 4 : result;
      if (result == this.productclassification.FTTHFTTB) {
        const dialogref = this.matdialog.open(ManageAdhocPopupComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: 'mat-dialog',
          width: "40%",
          data: {
            title: 'classification'
          }
        });
        dialogref.afterClosed().subscribe((result) => {
          if (result) {
            value.productClassification = result;
            this.productClassification = result
            this.getproduct(value)
          }
        })
      }
      else
        this.getproduct(value)
    })
  }

  // getproduct(value) {
  //   value.ProductChangePage=productchangeType.Adhoc
  //   this.form.get('product')?.enable();
  //   this.product.getAllProductByServiceProviderIdAndProductId(value).subscribe((result) => {
  //     this.productlist = result;
  //     this.productlist.forEach(item => {
  //       item.productCategoryName = item.productSubCategory.subCategoryName;
  //       this.groupedProducts = this.productlist.reduce((acc, product) => {
  //         let category = product.productCategoryName;
  //         let group = acc.find(g => g.categoryName === category);

  //         if (!group) {
  //           group = { categoryName: category, products: [] };
  //           acc.push(group);
  //         }

  //         group.products.push(product);
  //         return acc;
  //       }, []);
  //     });
  //   })
  // }
  getproduct(value) {
    value.ProductChangePage = productchangeType.Adhoc;
    this.form.get('product')?.enable();

    this.product.getAllProductByServiceProviderIdAndProductId(value).subscribe((result) => {

      this.productlist = result;
      const filteredList = result.filter(item =>
        !item.productSubCategory?.subCategoryName?.toLowerCase().includes("top")
      );

      filteredList.forEach(item => {
        item.productCategoryName = item.productSubCategory?.subCategoryName;
      });
      this.groupedProducts = filteredList.reduce((acc, product) => {
        const category = product.productCategoryName;
        let group = acc.find(g => g.categoryName === category);

        if (!group) {
          group = { categoryName: category, products: [] };
          acc.push(group);
        }

        group.products.push(product);
        return acc;
      }, []);

      const resellerItems = filteredList.filter(p => p.resellerActivate === true);
      this.groupedProducts.forEach(group => {
        group.products = group.products.filter(p => !p.resellerActivate);
      });

      const resellerCapped = resellerItems.filter(
        p => p.productSubCategory?.subCategoryName?.toLowerCase() === "capped"
      );

      const resellerUncapped = resellerItems.filter(
        p => p.productSubCategory?.subCategoryName?.toLowerCase() === "uncapped"
      );
      if (resellerCapped.length > 0) {
        this.groupedProducts.push({
          categoryName: "Reseller - Capped",
          products: resellerCapped
        });
      }

      if (resellerUncapped.length > 0) {
        this.groupedProducts.push({
          categoryName: "Reseller - Uncapped",
          products: resellerUncapped
        });
      }

    });
  }



  filteredGroupedProducts() {

    if (!this.searchTerm) {
      return this.groupedProducts;
    }


    return this.groupedProducts.map(group => ({
      categoryName: group.categoryName,
      products: group.products.filter(product =>
        product.aliasName.toLowerCase().includes(this.searchTerm.toLowerCase())

      )
    })).filter(group => group.products.length > 0);

  }

  onProductCategorySelect(event: MatSelectChange) {
    console.log(event.value);
    this.form.get('promoCode')?.setValue(null);
    let values = this.productlist.filter((item) => item.id === event.value);
    let value = values[0]
    console.log('product', value);
    if (this.debit.id != '0') {
      if (this.isResellerCustomer) {
        // this.form.controls['amount'].setValue(value.resellerTotalAmount)
        // this.form.controls['amount'].setValue(value.resellerTotalAmount)
        // this.form.controls['amount'].setValue(value.resellerTotalAmount)


        this.debit.amount = value.resellerTotalAmount;
        this.debit.vat = '15'
        this.debit.totalAmountExcludingVAT = value.resellerCostWithoutVat;
      }
      else {

        this.debit.amount = value.totalAmount
        this.debit.vat = '15'
        this.debit.totalAmountExcludingVAT = value.costWithoutVat;


        console.log('debitdata', this.debit)
      }

    }
    console.log(this.debit)

    this.selectedproductsubcategoryId = value.productSubCategory.id;
    this.isMultipleConnectionFee = value.isMultipleConnectionFee;
    this.withOnt = value.withOnt;
    this.withOutOnt = value.withOutOnt;
    this.lookupdataservice.GetAdHocAreaProdMapIdAndPromoCodeBySPAndProdId(this.form.value.serviceProvider, event.value).subscribe((result) => {
      this.application.areaProductMappingId = result.areaProductMappingId;
      this.promocodelist = result.promoCodeList

      debugger
      if (this.promocodelist.length == 1)
        this.form.get('promoCode')?.setValue(this.promocodelist[0].key);
      this.filteredList7 = [...this.promocodelist]

      console.log('this.promocodelist', this.promocodelist);

      console.log(this.application)
      if (this.form.value.serviceProvider == this.configuration.RainServiceProviderId) {
        Swal.fire('warning!,', 'This Service Provider is no longer Available', "warning");
      }
      else if (this.form.value.serviceProvider != this.configuration.RainServiceProviderId && this.isMultipleConnectionFee) {
        const dialogref = this.matdialog.open(ManageAdhocPopupComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: 'mat-dialog',
          width: "50%",
          data: {
            title: 'isont'
          }
        });
        dialogref.afterClosed().subscribe((result) => {
          if (result) {
            var connectionFeeId = "";
            if (result == 1) {
              connectionFeeId = this.withOnt
              this.isont = 1
            }
            else {
              connectionFeeId = this.withOutOnt
              this.isont = 0
            }
            this.tariffdataservice.GetProductDetailsById(connectionFeeId, false).subscribe((result) => {
              console.log(result)
              this.connectionFeeDetails = result;
              if (this.isResellerCustomer) {
                this.debit.onceOffFee = this.connectionFeeDetails.resellerTotalAmount
                this.debit.onceOffFeeExcludingVAT = this.connectionFeeDetails.resellerCostWithoutVat
                this.form.controls['amount'].setValue(this.debit.totalAmountExcludingVAT)
                this.form.controls['onceOffFee'].setValue(this.debit.onceOffFeeExcludingVAT)

              }
              else {
                this.debit.onceOffFee = this.connectionFeeDetails.totalAmount
                this.debit.onceOffFeeExcludingVAT = this.connectionFeeDetails.costWithoutVat
                this.form.controls['amount'].setValue(this.debit.amount)
                this.form.controls['onceOffFee'].setValue(this.debit.onceOffFee)
              }
              console.log('after popup', this.debit)


            })

          }
        })
      }
      else {
        this.tariffdataservice.GetConnectionFeeDetails(this.application.areaProductMappingId).subscribe((result) => {
          console.log(result);
          this.connectionFeeDetails = result;
          if (this.isResellerCustomer) {
            this.debit.onceOffFee = this.connectionFeeDetails.resellerTotalAmount
            this.debit.onceOffFeeExcludingVAT = this.connectionFeeDetails.resellerCostWithoutVat
            this.form.controls['amount'].setValue(this.debit.totalAmountExcludingVAT)
            this.form.controls['onceOffFee'].setValue(this.debit.onceOffFeeExcludingVAT)
          }
          else {
            this.debit.onceOffFee = this.connectionFeeDetails.totalAmount
            this.debit.onceOffFeeExcludingVAT = this.connectionFeeDetails.costWithoutVat
            this.form.controls['amount'].setValue(this.debit.amount)
            this.form.controls['onceOffFee'].setValue(this.debit.onceOffFee)
          }
        })
      }

    })

  }

  promofetch(event) {
    console.log(event.value);
    this.promocode = event.value

  }
  tenent() {
    let value = this.form.value.ownerShip
    if (value == '1')
      this.isshow = false;
    else
      this.isshow = true;
  }
  physicaltenent() {
    let value = this.form.value.ownerShip
    if (value == '1')
      this.ispshow = false;
    else
      this.ispshow = true;
  }
  save() {
    if (this.form.valid) {
      if (this.application.isVoice && !this.application.voiceType) {

      }
      else {
        this.saveAdHocApplicationForm()
      }
    }

  }
  saveAdHocApplicationForm() {
    var postData: any = {};
    this.customer.userId = this.customer.id;
    if (this.application.applicationStatus == ApplicationStatusType.Rejected)
      this.application.applicationStatus = ApplicationStatusType.ResubmitPending;
    if (this.application.applicationStatus == ApplicationStatusType.VumatelOrderRejected || this.application.applicationStatus == ApplicationStatusType.VumatelOrderCompleted) {
      this.application.applicationStatus = ApplicationStatusType.VumatelOrderApplicationPending;
    }
    this.application.ownerShip = this.form.value.ownerShip
    if (this.form.value.ownerShip == '2') {
      if (!this.form.value.legalOwnerName) {
        this.form.controls['legalOwnerName'].setErrors({ required: true });
        return;
      }
      if (!this.form.value.legalOwnerContactNumber) {
        this.form.controls['legalOwnerContactNumber'].setErrors({ required: true });
        return;
      }


      this.application.legalOwnerName = this.form.value.legalOwnerName
      this.application.legalOwnerContactNumber = this.form.value.legalOwnerContactNumber
    }
    if (this.promocode != null) {
      this.application.promoCode = this.promocode.value
      this.application.promotionId = this.promocode.key
    }
    this.application.reference = this.form.value.reference
    postData = this.application
    postData.productClassification = this.productClassification;
    // postData.isAdhocForm = true
    postData.applicationType = 2

    if (this.form.value.serviceProvider == 1) {
      postData.isVumatelArea = true;
      postData.isVumatelFibreHoods = this.form.value.VumatelArea
    }
    if (this.form.value.serviceProvider == 1 && this.isvumatel) {
      postData.isVumatelArea = false;
      postData.isVumatelFibreHoods = this.form.value.VumatelArea
    }
    postData.areaProductMappingId = this.application.areaProductMappingId;;
    postData.serviceProviderId = this.form.value.serviceProvider;
    if (this.connectionFeeDetails != null && this.connectionFeeDetails != undefined && this.connectionFeeDetails != '')
      postData.productOnceOffFeeId = this.connectionFeeDetails.id;

    if (!postData.customerAddressMapping) {
      postData.customerAddressMapping = {};
    }
    postData.promoCode = this.application.promoCode
    postData.promotionId = this.application.promotionId
    this.address = {
      addressLine1: this.form.value.addressLine1,
      addressLine2: this.form.value.addressLine2,
      city: this.form.value.city,
      country: this.form.value.country,
      pinCode: this.form.value.pinCode,
      reference: this.form.value.reference,
      region: this.form.value.region
    }
    postData.customerAddressMapping.address = this.address;
    postData.customerAddressMapping.customer = this.customer;
    postData.customerAddressMapping.customer.homeLanguage = this.form.value.homeLanguage;

    // postData.isAdhocForm = true;
    postData.applicationType = 2
    postData.customerAddressMapping.address.country = CountryType.SouthAfrica;
    postData.serviceProviderId = this.form.value.serviceProvider;
    //  postData.mobileNumber = this.form.value.primaryContactNumber;
    console.log(postData);
    if (postData.serviceProviderId == 43)
      postData.isLTE = true;
    this.applicationdataservice.saveApplication(postData).subscribe((result1) => {
      var postData: any = {}
      postData.applicationId = result1.id;
      postData.isONT = this.isont;
      this.applicationdataservice.saveAdditionalQuestions(postData).subscribe((result) => {
        console.log(result)
        Swal.fire({
          title: 'Success!',
          html: 'Application Created successfully,<br>Reference Number is <strong>' + result1.referenceNumber + '</strong>',
          icon: 'success',
        }).then((result) => {
          if (result.isConfirmed) {
            this.back()
          }
        });

      })

    })

  }
  physicalsave() {
    this.form.get('bank')?.setValidators(Validators.required);
    this.form.get('accountNumber')?.setValidators(Validators.required);
    this.form.get('accountType')?.setValidators(Validators.required);
    this.form.get('dateOfDebitOrderRun')?.setValidators(Validators.required);
    this.form.get('bank')?.updateValueAndValidity();
    this.form.get('accountNumber')?.updateValueAndValidity();
    this.form.get('accountType')?.updateValueAndValidity();
    this.form.get('dateOfDebitOrderRun')?.updateValueAndValidity();



    if (this.isResellerCustomer) {
      this.form.get('personname')?.setValidators(Validators.required);
      this.form.get('personLastName')?.setValidators(Validators.required);
      this.form.get('BusinessmobileNumber')?.setValidators(Validators.required);
      this.form.get('businessemail')?.setValidators(Validators.required);
      this.form.get('personIdentification')?.setValidators(Validators.required);
      this.form.get('personname')?.updateValueAndValidity();
      this.form.get('personLastName')?.updateValueAndValidity();
      this.form.get('BusinessmobileNumber')?.updateValueAndValidity();
      this.form.get('businessemail')?.updateValueAndValidity();
      this.form.get('personIdentification')?.updateValueAndValidity();
    }






    if (this.form.valid) {
      let value = this.form.getRawValue()
      var postData: any = {};
      this.application.ownerShip = value.ownerShip
      if (value.ownerShip == '2') {
        if (!value.legalOwnerName) {
          this.form.controls['legalOwnerName'].setErrors({ required: true });
          return;
        }
        if (!value.legalOwnerContactNumber) {
          this.form.controls['legalOwnerContactNumber'].setErrors({ required: true });
          return;
        }


        this.application.legalOwnerName = value.legalOwnerName
        this.application.legalOwnerContactNumber = value.legalOwnerContactNumber
      }
      this.address = {
        addressLine1: value.addressLine1,
        addressLine2: value.addressLine2,
        city: value.city,
        country: value.country,
        pinCode: value.pinCode,
        reference: value.reference,
        region: value.region,
      }
      if (!this.isResellerCustomer) {
        this.customer = {
          dateOfBirth: value.dateOfBirth,
          email: value.email,
          firstName: value.firstName,
          gender: value.gender,
          homeLanguage: value.homeLanguage,
          identificationNumber: value.identificationNumber,
          lastName: value.lastName,
          mobileNumber: value.primaryContactNumber,
          primaryContactNumber: value.primaryContactNumber,
          title: value.title,
        }
        this.debit = {
          ...this.debit,
          abbreviatedName: value.abbreviatedName,
          accountHolderName: value.accountHolderName,
          accountNumber: value.accountNumber.trim(),
          accountType: value.accountType,
          address: value.address,
          agreedOnDate: value.agreedOnDate,
          bank: value.bank,
          beneficiaryAddress: value.beneficiaryAddress,
          beneficiaryName: value.beneficiaryName,
          code: value.code,
          dateOfDebitOrderRun: value.dateOfDebitOrderRun,
          ipAddress: this.ip,
        }
      }
      if (this.isResellerCustomer) {
        this.customer = {
          ...this.customer,
          personname: value.personname,
          personLastName: value.personLastName,
          businessmobileNumber: value.BusinessmobileNumber,
          businessemail: value.businessemail,
          personIdentification: value.personIdentification
        }
      }



      this.application.reference = this.address.reference;
      postData = this.application
      postData.productClassification = this.productClassification;
      postData.isPhysicalContract = this.isPhysicalContract;
      if (this.form.value.promoCode)
        postData.promoCode = this.form.value.promoCode
      postData.areaProductMappingId = this.application.areaProductMappingId;
      if (this.connectionFeeDetails != null && this.connectionFeeDetails != undefined && this.connectionFeeDetails != '')
        postData.productOnceOffFeeId = this.connectionFeeDetails.id;

      if (!postData.customerAddressMapping) {
        postData.customerAddressMapping = {};
      }
      postData.customerAddressMapping.address = this.address;
      postData.customerAddressMapping.customer = this.customer;
      postData.customerAddressMapping.customer.user = { ...this.customer }

      postData.customerAddressMapping.customer.id = 0;
      if (this.isResellerCustomer)
        postData.isResellerCustomer = this.isResellerCustomer;
      // postData.isAdhocForm = true;

      postData.applicationType = 2
      postData.ipAddress = this.ip;
      if (value.serviceProvider == 1)
        postData.isVumatelArea = true;
      if (value.serviceProvider == 1 && this.isvumatel)
        postData.isVumatelArea = false;
      postData.debitForm = [];
      postData.debitForm.push(this.debit);
      postData.serviceProviderId = value.serviceProvider;
      postData.customerAddressMapping.address.country = CountryType.SouthAfrica;
      console.log(postData)
      this.applicationdataservice.saveApplication(postData).subscribe((result) => {
        var postData: any = {}
        postData.applicationId = result.id;
        postData.isONT = this.isont;
        this.applicationid = result.id
        this.referenceno = result.referenceNumber

        this.applicationdataservice.saveAdditionalQuestions(postData).subscribe((result) => {
          console.log(result)
          this.upload()
        })

      })
    }
  }

  restrictSpace(event: KeyboardEvent): void {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  back() {
    this.navigation.dashboard()
  }
  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options).replace(',', '');
  }
  showip(event) {
    if (event) {
      if (!this.first) {
        this.first = true;
        this.UtilityService.getIpAddress().subscribe((result) => {
          this.ip = result;
        })
      }
      this.dateip = true;
      this.dis = false
      this.date = this.formatDate(new Date())
    }
    else {
      this.dateip = false;
      this.dis = true;

    }
  }


  updateAddress(): void {
    const addressLine1 = this.form.get('addressLine1')?.value || '';
    const addressLine2 = this.form.get('addressLine2')?.value || '';
    const city = this.form.get('city')?.value || '';
    const region = this.form.get('region')?.value || '';
    const areacode = this.form.get('pinCode')?.value || '';
    const fullAddress = [addressLine1, addressLine2, city, region, areacode, "South Africa"]
      .filter(part => part.trim())
      .join(', ');

    this.form.get('address')?.setValue(fullAddress);
    const firstname = this.form.get('firstName')?.value || ''
    const lastname = this.form.get('lastName')?.value || ''
    const fullname = [firstname, lastname].join(' ');
    this.form.get('accountHolderName')?.setValue(fullname);

  }

  fileupload(id) {
    if (this.data[id - 1].action == false) {
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();
      inputElement.addEventListener('change', async (event: any) => {
        const files: FileList = (event.target as HTMLInputElement).files;
        if (!files || files.length === 0) {
          Swal.fire('Warning', 'Please upload a file', 'warning');
          return;
        }
        if (files.length > 1) {
          Swal.fire('Warning', 'Please upload only one file', 'warning');
          return;
        }
        this.file = files[0];
        this.fileName = this.file.name;
        console.log('file', this.fileName);
        this.filedate = this.formatDate(new Date());

        // Check for existing file names
        const fileExists = this.data.some(item => item.filename === this.fileName && item.action === true);
        if (fileExists) {
          Swal.fire('Warning', 'This file has already been uploaded. Please upload a different file.', 'warning');
          this.fileName = '';
          this.isFileSelected = false;
          document.body.removeChild(inputElement);
          return;
        }

        const fileExtension = this.fileName.split('.').pop().toLowerCase();
        const validExtensions = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'docx'];
        const validMimeTypes = [
          'image/png',
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];
        const isValidExtension = validExtensions.includes(fileExtension);
        const isValidMimeType = validMimeTypes.includes(this.file.type);
        if (!isValidExtension || !isValidMimeType) {
          Swal.fire(
            'Warning',
            `Please upload a correct file format (png, jpeg, jpg, pdf, doc, docx)`,
            'warning'
          );
          this.fileName = '';
          this.isFileSelected = false;
          document.body.removeChild(inputElement);
          return;
        }

        this.FileExtention = fileExtension;
        this.isFileSelected = true;
        console.log(this.file);
        document.body.removeChild(inputElement);
        this.data[id - 1].filename = this.fileName;
        this.data[id - 1].date = this.filedate;
        this.data[id - 1].action = true;
        this.data[id - 1].fileObject = this.file;

        this.dataSource = new MatTableDataSource(this.data);
        console.log(this.data);
      });
    } else {
      this.fileName = '';
      this.isFileSelected = false;
      this.data[id - 1].filename = '';
      this.data[id - 1].date = '';
      this.data[id - 1].action = false;
      this.data[id - 1].fileObject = null;
      this.dataSource = new MatTableDataSource(this.data);
    }
  }


  async upload() {
    let fileUploads = this.data.filter(item => item.action === true);
    console.log(fileUploads);

    if (fileUploads.length === 0) {
      Swal.fire('Warning', 'No files uploaded to send.', 'warning');
      return;
    }

    await this.apicall(fileUploads);

    Swal.fire(
      'Success!',
      `Application Created successfully,<br>Reference Number is <strong>${this.referenceno}</strong>`,
      'success'
    );
    Swal.fire({
      title: 'Success!',
      html: 'Application Created successfully,<br>Reference Number is <strong>' + this.referenceno + '</strong>',
      icon: 'success',
    }).then((result) => {
      if (result.isConfirmed) {
        this.back()
      }
    })
  }
  async apicall(fileUploads) {
    const uploadPromises = fileUploads.map((fileItem) => {
      let formData: FormData = new FormData();
      formData.append('documentType', fileItem.type);
      formData.append('customerApplicationId', this.applicationid);
      formData.append('file', fileItem.fileObject);

      return this.uploadFile(formData, fileItem);
    });

    await Promise.all(uploadPromises);
  }

  uploadFile(formData: FormData, fileItem: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.fiberservice.saveAppDocuments(formData).subscribe({
        next: (result) => {
          console.log(`File uploaded successfully: ${fileItem.filename}`);
          resolve(result);
        },
        error: (error) => {
          console.error(`Error uploading file: ${fileItem.filename}`, error);
          reject(error);
        }
      });
    });
  }

  onDropdownScroll(opened: boolean) {
    if (opened) {
      const panel = document.querySelector('.mat-select-panel');
      if (panel) {
        panel.addEventListener('scroll', this.onScroll.bind(this));
      }
    }
  }

  // Scroll event handler
  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 50 && !this.loadingMore) {
      this.loadingMore = true;
      console.log('Reached bottom - calling API...');
      // this.fetchMoreData();
    }
  }

  // Mock API call function
  // fetchMoreData() {
  //   setTimeout(() => {
  //     // Simulate API response
  //     const moreData = [
  //       { key: 'new1', value: 'New Customer 1' },
  //       { key: 'new2', value: 'New Customer 2' }
  //     ];
  //     this.filteredList = [...this.filteredList, ...moreData];
  //     this.loadingMore = false;
  //   },);
  // }

  // Called when filter changes
  onFilterChange(filteredData: any[], key) {
    console.log(key, 'key');

    if (key == 'normal')
      return this.filteredList = filteredData;
    else
      return this.filteredList5 = filteredData;

  }



  fetchAdditionalCustomers(search, key) {
    if (search.length >= 3) {
      console.log(key, 'key');

      setTimeout(() => {
        if (key === 'normal') {
          this.lookupdataservice.getVerifiedUserListBySearch(search).subscribe((result) => {
            const mergedList = result.filter((item) =>
              !this.verifyedlist.some((t) => t.key === item.key)
            );
            console.log(mergedList);

            this.verifyedlist = [...mergedList];

            if (result.length > 0) {
              this.filteredList = [...mergedList];
              this.onFilterChange(this.filteredList, key)
            } else {
              this.filteredList = [];
              this.onFilterChange(this.filteredList, key)

            }
          });
        } else {
          this.lookupdataservice.getResellerCustomerListBySearch(search).subscribe((result) => {
            const mergedList = result.filter((item) =>
              !this.verifyedlist.some((t) => t.key === item.key)
            );
            console.log(mergedList);

            this.verifyedlist = [...mergedList];

            if (result.length > 0) {
              this.filteredList = [...mergedList];
            } else {
              this.filteredList = [];
            }
          });
        }

      }, 1000);
    }
  }


  onEmailEnter() {
    const email = this.form.get('email')?.value;
    if (!email) return;

    this.lookupdataservice.getEmailAvailability(email).subscribe({
      next: (res) => {
        if (res.available) {
          this.emailError = '';
          this.form.get('email')?.setErrors(null);
        } else {
          this.emailError = res.message || 'Email is already taken';
          this.form.get('email')?.setErrors({ emailTaken: true });
        }
      },
      error: (err) => {
        this.emailError = err.error?.message || 'Error validating email';
        this.form.get('email')?.setErrors({ emailTaken: true });
      }
    });
  }
  fillDOBGender(e: any, formGroup: FormGroup) {
    const idvalue = e.target.value;

    if (idvalue.length === 13) {
      const Year = idvalue.substring(0, 2);
      const Month = idvalue.substring(2, 4);
      const Day = idvalue.substring(4, 6);
      const cutoff = (new Date()).getFullYear() - 2000;

      const datevalue = (parseInt(Year, 10) > cutoff ? '19' : '20') + Year + '/' + Month + '/' + Day;
      const dateOfBirth = this.datePipe.transform(datevalue, 'yyyy/MM/dd');

      const dateParts = dateOfBirth.split('/');
      const dateObject = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);


      formGroup.patchValue({
        dateOfBirth: dateObject
      });


      const genderCode = +idvalue.substring(6, 10);
      formGroup.patchValue({
        gender: genderCode < 5000 ? '2' : '1'
      });


      const genderTemp = formGroup.get('gender')?.value;
      this.genderValidator = !(genderTemp === '1' || genderTemp === '2');
    } else {

      const genderTemp = formGroup.get('gender')?.value;
      this.genderValidator = !(genderTemp === '1' || genderTemp === '2');
    }
  }





  onSearchTextChange(event: KeyboardEvent, key) {
    const input = event.target as HTMLInputElement;
    const searchText = input.value.trim();
    console.log('Typed text:', searchText);
    if (searchText) {
      this.filteredList = this.verifyedlist.filter(item =>
        item.value.toLowerCase().includes(searchText)
      );

      if (this.filteredList.length === 0) {
        this.fetchAdditionalCustomers(searchText, key);
      }
    } else {
      this.filteredList = [...this.verifyedlist];
    }
  }
}
